import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkladkaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#e9cc0c",
		d: "M 34.99,10.49 L 36.69,12.19 L 40.87,8.46 Z M 38.34,13.84 L 40.04,15.54 L 43.32,11 Z M 41.19,16.69 L 42.89,18.39 L 46.28,13.95 Z M 45.57,21.07 L 47.27,22.77 L 48.56,19.16 Z M 47.7,23.2 L 49.39,24.89 L 54.09,19.71 Z M 50.95,26.45 L 52.64,28.14 L 58.74,23.56 Z M 53.16,35.34 L 51.47,37.03 L 57.43,39.46 Z M 50.93,37.57 L 49.23,39.27 L 55.01,41.17 Z M 47.3,41.2 L 45.6,42.9 L 50.17,44.04 Z M 43.49,45.01 L 41.8,46.7 L 45.46,50.24 Z M 40.07,48.43 L 38.37,50.13 L 43.6,53.66 Z M 36.49,52.01 L 34.79,53.71 L 39.86,56.04 Z M 28.08,52.58 L 26.38,50.88 L 20.54,56.03 Z M 25.24,49.74 L 23.54,48.04 L 21.74,52.64 Z M 22.63,47.13 L 20.93,45.43 L 19.03,48.23 Z M 19.1,43.6 L 17.41,41.91 L 13.53,48.21 Z M 14.81,39.31 L 13.12,37.62 L 10.69,44.9 Z M 12.77,37.27 L 11.07,35.57 L 6.69,41.84 Z M 11.4,28.1 L 13.09,26.41 L 7.9,24.79 Z M 14.13,25.37 L 15.82,23.68 L 9.46,20.41 Z M 16.53,22.97 L 18.22,21.28 L 15.16,18.01 Z M 21.01,18.49 L 22.71,16.79 L 18.93,15.53 Z M 23.22,16.28 L 24.91,14.59 L 22.19,12.69 Z M 26.68,12.82 L 28.38,11.12 L 23.3,8.01 Z"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "rotate(45 32 32)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#08437f",
				d: "M 15.2,15.2 H 43.2 L 48.8,20.8 V 48.8 H 15.2 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ececec",
				d: "M 28,15.2 H 42.4 V 26.4 H 28 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#08437f",
				d: "M 31.2,16.8 H 39.2 V 26.4 H 31.2 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#ececec",
				d: "M 19.2,31.2 H 44.8 V 44.8 H 19.2 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#d80c13",
				d: "M 19.2,31.2 H 44.8 V 36.8 H 19.2 Z"
			})
		]
	})]
});
export default SvgSkladkaLogo;
